// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip___ZuVyS","chapter":"chapter___XROB_","time":"time___D_8Hs","cellText":"cellText___ib5Js"};